import React, {useEffect, useState} from 'react';
import Tree from 'react-d3-tree';
import './style.scss';
import {useSelector} from "react-redux";
import ContentSelector from "../../redux/reducers/contents/action";

interface IItem {
    data: IData,
    children?: IItem[],
    depth: number,
    height: number,
    parent?: IItem,
    x: number,
    y: number
}

interface IData {
    name: string;
    children: IItem[],
}

/*const data = {
    name: 'Systems',
    children: [
        {
            name: '001',
            children: [
                {
                    name: 'Tower001',
                },
                {
                    name: 'Propeller001',
                },
            ],
        },
        {
            name: '002',
            children: [
                {
                    name: 'Tower002',
                },
                {
                    name: 'Propeller002',
                },
            ],
        },
        {
            name: '003',
            children: [
                {
                    name: 'Tower003',
                },
                {
                    name: 'Propeller003',
                },
            ],
        },
        {
            name: '004',
            children: [
                {
                    name: 'Tower004',
                },
                {
                    name: 'Propeller004',
                },
            ],
        },
        {
            name: '005',
            children: [
                {
                    name: 'Tower005',
                },
                {
                    name: 'Propeller005',
                },
            ],
        },
        {
            name: '006',
            children: [
                {
                    name: 'Tower006',
                },
                {
                    name: 'Propeller006',
                },
            ],
        },
    ],
};*/

const SystemChart: React.FC = () => {

    const lines = useSelector(ContentSelector.getLines);

    const [data, setData] = useState({
        name: 'Systems',
        children: []
    });

    useEffect(() => {
        const _data = {
            name: 'Systems',
            children: Object.keys(lines).map(key => {
                return {
                    name: key,
                    children: lines[key].map(val => {
                        return {
                            name: 'WTG' + val,
                            children: [
                                {
                                    name: 'Tower' + val
                                },
                                {
                                    name: 'Properller' + val
                                }
                            ]
                        }
                    })
                }
            })
        };
        // @ts-ignore
        setData(_data)

    }, [lines])

    const zoomTo = (el: IItem) => {
        if (el.depth > 1) {
            const index = el.data.name.substring(el.data.name.length - 3);
            const name = el.depth === 2 ? 'than.' : 'canh.';
            // @ts-ignore
            window.v3d.puzzles.procedures.zoomTo(name + index)
        }
    }

    return (
        <div id="treeWrapper" style={{width: '100%', height: '70vh', zIndex: 99999}}>
            <Tree
                data={data}
                translate={{x: 500, y: 100}}
                orientation='vertical'
                rootNodeClassName="node--root"
                branchNodeClassName="node--branch"
                leafNodeClassName="node--leaf"
                onNodeClick={(e) => {
                    zoomTo(e as unknown as IItem)
                }}
                collapsible={false}
            />
        </div>
    )
}

export default SystemChart;


